var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircledIIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 33.5312C26.8015 33.5312 33.5312 26.8015 33.5312 18.5C33.5312 10.1985 26.8015 3.46875 18.5 3.46875C10.1985 3.46875 3.46875 10.1985 3.46875 18.5C3.46875 26.8015 10.1985 33.5312 18.5 33.5312ZM18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37Z",
    fill: "#0053C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4999 8.32492C19.5216 8.32492 20.3499 9.15319 20.3499 10.1749V21.275C20.3499 22.2967 19.5216 23.125 18.4999 23.125C17.4782 23.125 16.6499 22.2967 16.6499 21.275V10.1749C16.6499 9.15319 17.4782 8.32492 18.4999 8.32492Z",
    fill: "#0053C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6499 26.823C16.651 25.8013 17.4801 24.9739 18.5018 24.9749L18.556 24.975C19.5778 24.9761 20.4052 25.8052 20.4041 26.8269C20.403 27.8487 19.5739 28.6761 18.5522 28.675L18.498 28.6749C17.4762 28.6739 16.6488 27.8447 16.6499 26.823Z",
    fill: "#0053C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledIIcon);
export default __webpack_public_path__ + "static/media/circled_i_icon.2aa441fff873bd4983b019949db95204.svg";
export { ForwardRef as ReactComponent };